import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "movie-info" }
const _hoisted_3 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_movie_rating = _resolveComponent("movie-rating")!

  return (_openBlock(), _createElementBlock("div", {
    class: "movie-poster",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.movieClicked && _ctx.movieClicked(...args)))
  }, [
    _createElementVNode("img", {
      class: "poster",
      src: _ctx.imgUrl(_ctx.movie.backdrop_path),
      alt: _ctx.movie.title
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.movie.title), 1),
      _createVNode(_component_movie_rating, {
        rating: _ctx.movie.vote_average
      }, null, 8, ["rating"])
    ])
  ]))
}